import React, { Component } from 'react';

class DirectionBtn extends Component {
    render() {
        const { click, size, btnColor, btnName, active } = this.props;
        return (
            <button onClick={click} className={`directionBtn ${size} ${btnColor} ${btnName} ${active}`} >
                <span>{btnName}</span>
            </button>
        );
    }
}

DirectionBtn.defaultProps = {
    btnColor: 'blue',
    btnName: 'Prev',
    active: 'active',
    click: () => {}
}

export default DirectionBtn;


// WEBPACK FOOTER //
// ./src/components/Buttons/DirectionBtn/index.js